module.exports = __webpack_public_path__ + "img/styria_media_design_logo.ac58e8fe.svg";